import { render, staticRenderFns } from "./UploadFoldersDropzone.vue?vue&type=template&id=48d8e4b4&"
import script from "./UploadFoldersDropzone.vue?vue&type=script&lang=js&"
export * from "./UploadFoldersDropzone.vue?vue&type=script&lang=js&"
import style0 from "./UploadFoldersDropzone.vue?vue&type=style&index=0&id=48d8e4b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports